module.exports = __webpack_public_path__ + "ba4f45b9c0e5b8010315cb61a1f717b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-6.png
// module id = 410
// module chunks = 0